export class APIError extends Error {
  readonly status: number;
  readonly details: unknown;

  constructor(message: string, status: number, details: unknown) {
    super(message);
    this.name = 'APIError';
    this.status = status;
    this.details = details;
  }

  get contactSaved(): boolean {
    return typeof this.details === 'object' && this.details !== null
      && 'contact_saved' in this.details && this.details.contact_saved === true;
  }

  get code(): string | undefined {
    return typeof this.details === 'object' && this.details !== null
      && 'code' in this.details && typeof this.details.code === 'string'
      ? this.details.code : undefined;
  }

  get verificationRequired(): boolean {
    return this.status === 400 && this.code === 'verification_required';
  }
}

// Reset only the invalid proof/code, never the customer's feedback draft.
export function recoverFeedbackVerification<T extends { verified: boolean; code: string }>(state: T, error: unknown): T {
  return error instanceof APIError && error.verificationRequired
    ? { ...state, verified: false, code: '' } : state;
}
